import React from 'react';
import { t } from 'ttag';
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  TextField,
  FormHelperText
} from '@material-ui/core';
import { Button } from '@coolremote/shared';

const SubscriptionCodeDialog = ({
  open,
  subscriptionCode,
  error,
  onCodeChange,
  onLogout,
  onAccept
}) => {
  return (
    <Dialog
      open={open}
      onClose={() => {}}
      aria-labelledby="subscription-dialog-title"
      aria-describedby="subscription-dialog-description"
    >
      <DialogTitle id="subscription-dialog-title">
        {t`Accept Service Provider Invite`}
      </DialogTitle>
      <DialogContent>
        <DialogContentText id="subscription-dialog-description">
          {t`As a service provider, please enter your subscription code to accept the invite`}
        </DialogContentText>
        <TextField
          fullWidth={true}
          variant="outlined"
          label={t`Subscription Code`}
          onChange={(e) => onCodeChange(e.target.value)}
          value={subscriptionCode}
          error={!!error?.length}
          style={{ marginTop: '16px' }}
        />
        {!!error?.length && (
          <FormHelperText error={true} style={{ color: 'red' }}>
            {error}
          </FormHelperText>
        )}
      </DialogContent>
      <DialogActions>
        <Button
          onClick={onLogout}
          style={{ backgroundColor: '#666666', color: '#ffffff' }}
        >
          {t`Logout`}
        </Button>
        <Button
          onClick={onAccept}
          style={{ backgroundColor: '#1976d2', color: '#ffffff' }}
        >
          {t`Accept Invite`}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export { SubscriptionCodeDialog };
